(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import PhysicalDataPlugin from '@kailona/plugin-physical-data';
import ActivitiesPlugin from '@kailona/plugin-activities';
import VitalsPlugin from '@kailona/plugin-vitals';
import DocumentsPlugin from '@kailona/plugin-documents';
import LaboratoryPlugin from '@kailona/plugin-laboratory';
import DiabetesPlugin from '@kailona/plugin-diabetes';
var _default = {
  basename: OC.generateUrl('/apps/ehr'),
  fontsPath: {
    nunitosans: OC.filePath('ehr', 'fonts', 'nunitosans')
  },
  plugins: [PhysicalDataPlugin, ActivitiesPlugin, VitalsPlugin, DocumentsPlugin, LaboratoryPlugin, DiabetesPlugin],
  settings: {
    fhirBaseUrl: OC.generateUrl('/apps/ehr/fhir'),
    adminSettingsUrl: OC.generateUrl('/apps/ehr/settings/admin'),
    mailBaseUrl: OC.generateUrl('/apps/ehr/mail'),
    documentBaseUrl: OC.generateUrl('/apps/ehr/documents')
  },
  currentUser: {
    id: OC.getCurrentUser().uid,
    name: OC.getCurrentUser().displayName
  }
};
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/config/default.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();